export default {
  export:{
    conceptscheme: {
      title: "Export",
      description: "Select which sections to include in the export:",
      format: "Export format:",
      formats: { turtle: "Turtle (*.ttl)", nTriples: "N-Triples (*.n3)" },
      includeConcepts: "Include detailed information about concepts in the export",
      includeRelated: "Include detailed information about related items in the export (if available)",
      preparing: "Preparing…",
      fetchingIriList: "Fetching the IRI list…",
      fetchingData: "Fetching data for {{name}}",
      exporting: "Exporting: {{title}}…",
      packingZip: "Packing ZIP…",
      zipReady: "ZIP is ready. Starting the download…",
      done: "Done.",
      executionLog: "Execution log",
      emptyLog: "The log is empty.",
      exportError: "Export error",
      downloadLink: "Download link:",
      download: "Download {{filename}}",
      downloadHint: "If the download did not start automatically, click the link above.",
      cancel: "Cancel",
      close: "Close",
      export: "Export",
      log: {
        started: "ZIP export started.",
        exporting: "Exporting: {{title}}",
        searchingRelated: "Searching for related objects in {{id}}",
        fileAdded: "File added: {{file}}",
        zipCreated: "ZIP created: {{filename}}",
        completed: "Export completed.",
        error: "Export error: {{error}}"
      }
    }
  },
  import: {
    conceptscheme: {
      title: "Import object",
      close: "Close",
      cancel: "Cancel",
      import: "Import",
      selectFile: "Select file",
      file: "File: {{filename}}",
      noFileSelected: "No file selected",
      whatToImport: "What to import:",
      importSchemes: "Import concept scheme(s)",
      deleteBeforeImport: "Delete before import",
      replacePurlServer: "Replace PURL server",
      sourcePurlServer: "Source PURL server",
      targetPurlServer: "Target PURL server",
      foundSchemes: "Found: concept schemes — {{count}}",
      error: "Error",
      success: "Import completed successfully.",
      status: {
        preparing: "Preparing...",
        checkingZip: "Checking ZIP archive...",
        readingArchive: "Reading archive...",
        searchingManifest: "Searching for export.json...",
        readingManifest: "Reading export.json...",
        checkingManifestFiles: "Checking files from export.json...",
        analysisComplete: "Analysis complete. Select what to import.",
        extractingData: "Extracting data...",
        importingObject: "Importing object...",
        objectImported: "Object imported.",
        preparingImport: "Preparing import...",
        importComplete: "Import complete."
      },
      errors: {
        import: "Import error.",
        unknownRdfFormat: "Could not determine the RDF format of file \"{{filename}}\".",
        sparql: "SPARQL query execution failed.",
        notZip: "The selected file is not a ZIP archive.",
        emptyArchive: "The archive is empty or contains no files.",
        manifestMissing: "The required export.json file is missing from the archive.",
        manifestInvalidJson: "Could not parse export.json as JSON.",
        manifestNotArray: "export.json must contain a JSON array of records.",
        noManifestItems: "No items with a file field were found in export.json.",
        filesMissing: "Files listed in export.json are missing from the archive: {{files}}",
        graphMissing: "The import graph is not specified.",
        analysis: "Archive analysis error.",
        objectImport: "Object import: {{error}}",
        nothingSelected: "Nothing is selected for import.",
        purlRequired: "Specify both the source and target PURL servers to replace PURLs."
      },
      warnings: {
        nothingToImport: "Nothing to import",
        uploadAnotherFile: "Upload another file",
        configurationError: "Configuration error",
        configurePurl: "Disable PURL server replacement or configure it."
      }
    }
  }
}
